<template>
  <el-tag style="height: auto" :type="getTagType"
    >Nombre: {{ activity.name }} <br />
    {{ $t('common_words.code') }}: {{ activity.code }}
    <br />
    {{ $t('common_words.c_of_homologation') }}: {{ activity.homologated_code }}
    <br />
    {{ $t('common_words.cost_center') }}: {{ activity.cost_center }} <br />
    {{ $t('common_words.type_capture') }}: {{ activity.catch_type }} <br />
    {{ $t('common_words.minimum') }}: {{ activity.minimum }}
    {{ activity.activity_unit_payment.abbreviation }}
    <br />
    {{ $t('common_words.maximum') }}: {{ activity.maximum }}
    {{ activity.activity_unit_payment.abbreviation }}
    <br />
    {{ $t('labor.unit_of_payment') }}:
    {{ activity.activity_unit_payment.name }}
    <br />
    {{ $t('common_words.production_unit') }}:
    {{ activity.activity_unit_production.name }}
    <br />
    {{ $t('labor.additional_activity') }}?:
    {{
      activity.aditional_activity
        ? $t('common_words.yes')
        : $t('common_words.no')
    }}
    <br />
    {{ $t('labor.group_activities') }}?:
    {{
      activity.group_activities ? $t('common_words.yes') : $t('common_words.no')
    }}
    <br />
    {{ $t('labor.assist_control') }}?:
    {{
      activity.assist_control ? $t('common_words.yes') : $t('common_words.no')
    }}
  </el-tag>
</template>
<script>
export default {
  name: 'activities-tag',
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getTagType() {
      return this.activity.deleted_at ? `danger` : `info`;
    },
  },
};
</script>
